import { Record, Union } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import { tuple_type, option_type, record_type, list_type, class_type, string_type, int32_type, union_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { Provider, BazaarCategory_$reflection, Product_$reflection } from "./Shopfoo.Domain.Types/Catalog.js";
import { SearchResultModule_status, Searcher__Product, SearchResultModule_build, Searcher_$ctor_Z1481DE65, Column, Highlighting as Highlighting_1, CaseMatching, SearchConfig, SearchConfig_$reflection, SearchTargetResult_$reflection, Column_$reflection } from "./Search.js";
import { OLID_$reflection } from "./Shopfoo.Domain.Types/Common.js";
import { exists, ofSeq, empty } from "./fable_modules/fable-library-js.4.24.0/Set.js";
import { equals, compare } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { sortBy, sortByDescending } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { map, append, empty as empty_1, singleton, collect, delay, toList } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { AppTranslations__get_Product, TranslationPages_Product__StoreCategoryOf_Z2CEE261C } from "./Shopfoo.Shared/Translations.js";
import { Set_$007CEmpty$007CNotEmpty$007C } from "./Shopfoo.Common/Common.js";

export class SortDirection extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Ascending", "Descending"];
    }
}

export function SortDirection_$reflection() {
    return union_type("Shopfoo.Client.Filters.SortDirection", [], SortDirection, () => [[], []]);
}

export function SortDirection__Toggle(this$) {
    if (this$.tag === 1) {
        return new SortDirection(0, []);
    }
    else {
        return new SortDirection(1, []);
    }
}

export class SortKeyPart extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Num", "Text"];
    }
}

export function SortKeyPart_$reflection() {
    return union_type("Shopfoo.Client.Filters.SortKeyPart", [], SortKeyPart, () => [[["Item", int32_type]], [["Item", string_type]]]);
}

export class AutoIndex {
    constructor() {
        this.index = -1;
    }
}

export function AutoIndex_$reflection() {
    return class_type("Shopfoo.Client.Filters.AutoIndex", undefined, AutoIndex);
}

export function AutoIndex_$ctor() {
    return new AutoIndex();
}

export function AutoIndex__Next(_) {
    _.index = ((_.index + 1) | 0);
    return _.index | 0;
}

export class Row extends Record {
    constructor(Index, Product, SearchResult) {
        super();
        this.Index = (Index | 0);
        this.Product = Product;
        this.SearchResult = SearchResult;
    }
}

export function Row_$reflection() {
    return record_type("Shopfoo.Client.Filters.Row", [], Row, () => [["Index", int32_type], ["Product", Product_$reflection()], ["SearchResult", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [Column_$reflection(), list_type(SearchTargetResult_$reflection())])]]);
}

export class CategoryFilters extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Bazaar", "Books"];
    }
}

export function CategoryFilters_$reflection() {
    return union_type("Shopfoo.Client.Filters.CategoryFilters", [], CategoryFilters, () => [[["category", option_type(BazaarCategory_$reflection())]], [["authorId", option_type(OLID_$reflection())], ["tag", option_type(string_type)]]]);
}

export const CategoryFiltersModule_Defaults_bazaar = new CategoryFilters(0, [undefined]);

export const CategoryFiltersModule_Defaults_books = new CategoryFilters(1, [undefined, undefined]);

export class Filters extends Record {
    constructor(CategoryFilters, Search, SortBy) {
        super();
        this.CategoryFilters = CategoryFilters;
        this.Search = Search;
        this.SortBy = SortBy;
    }
}

export function Filters_$reflection() {
    return record_type("Shopfoo.Client.Filters.Filters", [], Filters, () => [["CategoryFilters", option_type(CategoryFilters_$reflection())], ["Search", SearchConfig_$reflection()], ["SortBy", option_type(tuple_type(Column_$reflection(), SortDirection_$reflection()))]]);
}

export function Filters__get_Provider(filters) {
    const matchValue = filters.CategoryFilters;
    if (matchValue == null) {
        return undefined;
    }
    else if (matchValue.tag === 1) {
        return new Provider(1, []);
    }
    else {
        return new Provider(0, []);
    }
}

export function Filters__get_BazaarCategory(filters) {
    const matchValue = filters.CategoryFilters;
    if (matchValue == null) {
        return undefined;
    }
    else if (matchValue.tag === 1) {
        return undefined;
    }
    else {
        const category = matchValue.fields[0];
        return category;
    }
}

export function Filters__get_BooksAuthorId(filters) {
    const matchValue = filters.CategoryFilters;
    if (matchValue == null) {
        return undefined;
    }
    else if (matchValue.tag === 0) {
        return undefined;
    }
    else {
        const authorId = matchValue.fields[0];
        return authorId;
    }
}

export function Filters__get_BooksTag(filters) {
    const matchValue = filters.CategoryFilters;
    if (matchValue == null) {
        return undefined;
    }
    else if (matchValue.tag === 0) {
        return undefined;
    }
    else {
        const tag = matchValue.fields[1];
        return tag;
    }
}

export function Filters__ClearSearchSort(filters) {
    let bind$0040;
    return new Filters(filters.CategoryFilters, (bind$0040 = filters.Search, new SearchConfig(bind$0040.Columns, bind$0040.CaseMatching, bind$0040.Highlighting, undefined)), undefined);
}

export function Filters__WithCategoryFilters_ZE408C9D(filters, categoryFilters) {
    return new Filters(categoryFilters, filters.Search, filters.SortBy);
}

export function Filters__ToBazaar_Z3BF3079(filters, category) {
    return Filters__WithCategoryFilters_ZE408C9D(filters, new CategoryFilters(0, [category]));
}

export function Filters__ToBooks_Z4329286C(filters, authorId, tag) {
    return Filters__WithCategoryFilters_ZE408C9D(filters, new CategoryFilters(1, [authorId, tag]));
}

export function Filters__ToBooks(filters) {
    return Filters__ToBooks_Z4329286C(filters, undefined, undefined);
}

export function Filters__ToBooksWithAuthor_1D9C746C(filters, authorId) {
    return Filters__ToBooks_Z4329286C(filters, authorId, Filters__get_BooksTag(filters));
}

export function Filters__ToBooksWithTag_6DFDD678(filters, tag) {
    return Filters__ToBooks_Z4329286C(filters, Filters__get_BooksAuthorId(filters), tag);
}

export const FiltersModule_none = new Filters(undefined, new SearchConfig(empty({
    Compare: compare,
}), new CaseMatching(1, []), new Highlighting_1(1, []), undefined), undefined);

export const FiltersModule_defaults = new Filters(FiltersModule_none.CategoryFilters, (() => {
    const bind$0040 = FiltersModule_none.Search;
    return new SearchConfig(ofSeq([new Column(1, []), new Column(2, []), new Column(3, []), new Column(4, []), new Column(5, []), new Column(6, []), new Column(7, [])], {
        Compare: compare,
    }), bind$0040.CaseMatching, new Highlighting_1(0, []), bind$0040.Term);
})(), FiltersModule_none.SortBy);

class FiltersModule_FiltersOperator {
    constructor(filters, translations) {
        let matchValue;
        this.filters = filters;
        this.translations = translations;
        this.search = Searcher_$ctor_Z1481DE65(this.filters.Search, this.translations);
        this.sortProducts = ((matchValue = this.filters.SortBy, (matchValue != null) ? ((matchValue[1].tag === 1) ? ((list_1) => sortByDescending((row_1) => FiltersModule_FiltersOperator__getSortKey_4344FAA9(this, row_1), list_1, {
            Compare: compare,
        })) : ((list) => sortBy((row) => FiltersModule_FiltersOperator__getSortKey_4344FAA9(this, row), list, {
            Compare: compare,
        }))) : ((x) => x)));
    }
}

function FiltersModule_FiltersOperator_$reflection() {
    return class_type("Shopfoo.Client.Filters.FiltersModule.FiltersOperator", undefined, FiltersModule_FiltersOperator);
}

function FiltersModule_FiltersOperator_$ctor_ZEB124F(filters, translations) {
    return new FiltersModule_FiltersOperator(filters, translations);
}

function FiltersModule_FiltersOperator__filter_Z522604AA(_, products) {
    const index = AutoIndex_$ctor();
    return _.sortProducts(toList(delay(() => collect((product_1) => {
        let matchValue, matchValue_1, matchValue_2, selectedAuthorId, matchValue_4, matchValue_5, selectedTag, matchValue_7, matchValue_8, selectedCategory;
        const searchResult_1 = SearchResultModule_build(_.filters.Search, (column) => Searcher__Product(_.search, product_1, column));
        return (((((_.filters.Search.Term == null) ? true : ((matchValue = SearchResultModule_status(searchResult_1), matchValue.tag === 1))) && ((matchValue_1 = Filters__get_BooksAuthorId(_.filters), (matchValue_2 = product_1.Category, (matchValue_1 != null) ? ((matchValue_2.tag === 1) ? ((selectedAuthorId = matchValue_1, exists((author) => equals(author.OLID, selectedAuthorId), matchValue_2.fields[0].Authors))) : true) : true)))) && ((matchValue_4 = Filters__get_BooksTag(_.filters), (matchValue_5 = product_1.Category, (matchValue_4 != null) ? ((matchValue_5.tag === 1) ? ((selectedTag = matchValue_4, exists((tag) => (tag === selectedTag), matchValue_5.fields[0].Tags))) : true) : true)))) && ((matchValue_7 = Filters__get_BazaarCategory(_.filters), (matchValue_8 = product_1.Category, (matchValue_7 != null) ? ((matchValue_8.tag === 0) ? ((selectedCategory = matchValue_7, equals(matchValue_8.fields[0].Category, selectedCategory))) : true) : true)))) ? singleton(new Row(AutoIndex__Next(index), product_1, searchResult_1)) : empty_1();
    }, products))));
}

export function FiltersModule_FiltersOperator__getSortKey_4344FAA9(this$, row) {
    return toList(delay(() => {
        let matchValue_1, matchValue_3, matchValue_4, matchValue_5, matchValue_6;
        const matchValue = this$.filters.SortBy;
        if (matchValue != null) {
            switch (matchValue[0].tag) {
                case 1:
                    return singleton(new SortKeyPart(1, [row.Product.SKU.Value]));
                case 2:
                    return singleton(new SortKeyPart(1, [row.Product.Title]));
                case 3:
                    return singleton(new SortKeyPart(1, [row.Product.Description]));
                case 4:
                    return append((matchValue_1 = row.Product.Category, (matchValue_1.tag === 0) ? singleton(new SortKeyPart(1, [TranslationPages_Product__StoreCategoryOf_Z2CEE261C(AppTranslations__get_Product(this$.translations), matchValue_1.fields[0].Category)])) : (empty_1())), delay(() => singleton(new SortKeyPart(1, [row.Product.Title]))));
                case 5: {
                    const matchValue_2 = row.Product.Category;
                    if (matchValue_2.tag === 1) {
                        return singleton(new SortKeyPart(1, [matchValue_2.fields[0].Subtitle]));
                    }
                    else {
                        return empty_1();
                    }
                }
                case 6:
                    return append((matchValue_3 = row.Product.Category, (matchValue_3.tag === 1) ? ((matchValue_4 = matchValue_3.fields[0].Authors, (Set_$007CEmpty$007CNotEmpty$007C(matchValue_4).tag === 1) ? map((author) => (new SortKeyPart(1, [author.Name])), matchValue_4) : singleton(new SortKeyPart(1, [""])))) : (empty_1())), delay(() => singleton(new SortKeyPart(1, [row.Product.Title]))));
                case 7:
                    return append((matchValue_5 = row.Product.Category, (matchValue_5.tag === 1) ? ((matchValue_6 = matchValue_5.fields[0].Tags, (Set_$007CEmpty$007CNotEmpty$007C(matchValue_6).tag === 1) ? map((tag) => (new SortKeyPart(1, [tag])), matchValue_6) : singleton(new SortKeyPart(1, [""])))) : (empty_1())), delay(() => singleton(new SortKeyPart(1, [row.Product.Title]))));
                default:
                    return singleton(new SortKeyPart(0, [row.Index]));
            }
        }
        else {
            return empty_1();
        }
    }));
}

export function FiltersModule_apply(products, translations, filters) {
    return FiltersModule_FiltersOperator__filter_Z522604AA(FiltersModule_FiltersOperator_$ctor_ZEB124F(filters, translations), products);
}

